<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-processing-individual" color="white"></help-link>
                    <v-btn dark v-show="!loading&&payroll_employee&&payroll_employee.status>0" @click="generatePayslipPDF(payroll_employee)" :loading="loading_pdf" icon small title="Export to PDF">
                        <v-icon>fas fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn color="primary" v-if="!loading&&canGenerate" :loading="loading_status" @click="generatePayrollByUser()" style="color:white" :disabled="openCutOffPeriod||closedCutOffPeriod" title="Process Payroll">
                        Process Payroll
                    </v-btn>
                    <div v-if="showMenuButtons">
                        <v-menu left v-if="hasEditAndApproverRights||hasDeleteRights" v-model="menu_status" offset-y :disabled="hasEditAndApproverRights&&disabledForEditAndApproverRights">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(payroll_employee.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(payroll_employee.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||rejected_status)" :key="1" @click="generatePayrollByUser()" title="Reprocess payroll">
                                    <v-list-tile-title small>Reprocess</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasDeleteRights&&(created_status||rejected_status)" :key="2" @click="showDelete" title="Delete payroll">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasEditAndApproverRights&&created_status" :key="3" @click="forReview" title="Set payroll to For Review">
                                    <v-list-tile-title>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasEditAndApproverRights&&(forReview_status||rejected_status)" :key="4" @click="approvePayroll" title="Approve payroll">
                                    <v-list-tile-title>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasEditAndApproverRights&&(forReview_status||approved_status||credited_status)" :key="5" @click="rejectPayroll" title="Reject payroll">
                                    <v-list-tile-title>Reject</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasEditAndApproverRights&&approved_status" :key="6" @click="payrollCredited" title="Set status to Credited">
                                    <v-list-tile-title>Credited</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-menu left v-if="!hasEditAndApproverRights&&(hasEditRights||hasApproverRights||hasDeleteRights)" v-model="menu_status" offset-y :disabled="(hasEditRights&&disabledEditRights)||(hasApproverRights&&disabledApproverRights)">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(payroll_employee.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(payroll_employee.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" :key="1" @click="generatePayrollByUser()" title="Regenerate payroll">
                                    <v-list-tile-title small>Re-Generate</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasDeleteRights&&(created_status||rejected_status)" :key="2" @click="showDelete" title="Delete payroll">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasEditRights&&created_status" :key="3" @click="forReview" title="Set payroll to For Review">
                                    <v-list-tile-title>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasApproverRights&&(forReview_status||rejected_status)" :key="4" @click="approvePayroll" title="Approve payroll">
                                    <v-list-tile-title>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasApproverRights&&(forReview_status||approved_status||credited_status)" :key="5" @click="rejectPayroll" title="Reject payroll">
                                    <v-list-tile-title>Reject</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasEditRights&&approved_status" :key="6" @click="payrollCredited" title="Set status to Credited">
                                    <v-list-tile-title>Credited</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>

            <v-alert v-if="!loading&&error" :value="true" color="error" icon="error" outline class="section-alert">
                Error encountered. Please contact support.
            </v-alert> 
            <v-alert v-if="!loading&&hasStartedLaterThanCutoffStartDate" :value="true" color="info" icon="info" outline class="section-alert">
                <b>{{payroll_employee.name}}</b> start date was <b>{{employment.startDate|moment('MMM DD, YYYY')}}</b> and payroll computation will be pro-rated.
            </v-alert> 
            <v-alert v-if="!loading&&hasResigned" :value="true" color="info" icon="info" outline class="section-alert">
                <b>{{payroll_employee.name}}</b> has already resigned and the last working date was <b>{{employment.endDate|moment('MMM DD, YYYY')}}</b>.
            </v-alert> 
            <v-alert v-if="!loading&&payroll_employee&&payroll_employee.timeReportStatus!=commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline class="section-alert">
                {{payroll_employee.name}}'s timesheet is currently <b>{{commonfn.getStatusDescription(payroll_employee.timeReportStatus)}}</b>. You won't be able to generate Payroll until timesheet is approved.
            </v-alert>  
            <v-alert v-if="!loading&&openCutOffPeriod" :value="true" color="warning" icon="warning" outline class="section-alert">
                This cutoff period is still open.
            </v-alert> 
            <v-alert v-if="closedCutOffPeriod" :value="true" color="warning" icon="warning" outline class="section-alert">
                This cutoff period is already closed. You will not be able to modify payroll data.
            </v-alert>
            <v-alert v-if="approved_status" :value="true" color="info" icon="info" outline dismissible class="section-alert">
                Once payroll has been credited to employee's account, change status to <b>Credited</b>.
            </v-alert>
            
            <v-expansion-panel v-if="!loading" v-model="panel" expand class="mt-5">
                <!-- Employee Details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">EMPLOYEE</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading&&payroll_employee" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employee :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            <v-chip @click="viewUserProfile(payroll_employee, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(payroll_employee.userId)"></v-img>
                                                </v-avatar>
                                                {{payroll_employee.name}}
                                            </v-chip>
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employee Id : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{payroll_employee.employeeId}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Pay Grade : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{payroll_employee.payGrade}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Salary Type : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{commonfn.getSalaryTypeName(this.payroll_employee.salaryType)}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Coverage :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{getCoverageDesc}} 
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Cutoff Type : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{cutoff_settings.description}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Date Created :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{payroll_employee.createdOn | moment("MMM DD, YYYY hh:mma")}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout v-if="isHourlySalaryType" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Total Hours : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{numFormat.formatNumber(payroll_employee.cutOffHours)}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- EARNINGS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">EARNINGS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading&&payroll_employee&&payroll_employee.status>0" >
                            
                            <!-- basic salary -->
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left"><h4>Salary & Benefits</h4></v-flex>
                                <v-flex xs6 class="text-xs-right"><h4>Amount</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">Basic Salary (this cutoff)</v-flex>
                                <v-flex xs6 class="text-xs-right">{{numFormat.formatNumber(payroll_employee.cutOffBasicSalary)}}</v-flex>
                            </v-layout>
                            
                            <!-- benefits -->
                            <v-layout row wrap v-for="(item,index) in deminimis_benefits" :key="index" :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    {{item.benefitName}} (deminimis)
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    {{numFormat.formatNumber(item.cutOffAmount)}}
                                </v-flex>      
                            </v-layout>  
                            <v-layout row wrap v-for="(item,index) in other_benefits" :key="index" :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    {{item.benefitName}} (other benefits)
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    {{numFormat.formatNumber(item.cutOffAmount)}}
                                </v-flex>       
                            </v-layout>  
                            <v-layout row wrap v-for="(item,index) in fringe_benefits" :key="index" :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    {{item.benefitName}} (fringe benefits)
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    {{numFormat.formatNumber(item.cutOffAmount)}}
                                </v-flex> 
                            </v-layout>

                            <!-- overtime -->
                            <div v-if="!isMobile && overtime.length>0" ><br>
                                <v-layout row wrap class="section-layout"> 
                                    <v-flex xs7 class="text-xs-left"><h4>Overtime</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>Hourly Rate Amount</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>OT Rate</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>Hours</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in overtime" :key="index" row wrap class="section-layout"> 
                                    <v-flex xs7 class="text-xs-left">{{item.description}}</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(item.hourlyRate)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.rate)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.hours)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.amount)}}</v-flex>
                                </v-layout>
                            </div>
                            <div v-if="isMobile && overtime.length>0" >
                                <v-layout row wrap class="section-layout-mobile"> 
                                    <v-flex xs6 class="text-xs-left"><h4>Overtime</h4></v-flex>
                                    <v-flex xs6 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in overtime" :key="index" row wrap class="section-layout-mobile"> 
                                    <v-flex xs6 class="text-xs-left">{{item.description}}</v-flex>
                                    <v-flex xs6 class="text-xs-right">{{numFormat.formatNumber(item.amount)}}</v-flex>
                                </v-layout>
                            </div>

                            <!-- night diff -->
                            <div v-if="!isMobile && night_diff.length>0" ><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs6 class="text-xs-left"><h4>Night Differential</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>Hourly Rate Amount</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>OT Rate</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>ND Rate</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>ND Hours</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>ND Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in night_diff" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs6 class="text-xs-left">{{item.description}}</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(item.hourlyRate)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.rate)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.ndRate)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.ndHours)}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.ndAmount)}}</v-flex>
                                </v-layout>
                            </div>
                            <div v-if="isMobile && night_diff.length>0" ><br>
                                <v-layout row wrap class="section-layout-mobile"> 
                                    <v-flex xs6 class="text-xs-left"><h4>Night Differential</h4></v-flex>
                                    <v-flex xs6 class="text-xs-right"><h4>ND Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in night_diff" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs6 class="text-xs-left">{{item.description}}</v-flex>
                                    <v-flex xs6 class="text-xs-right">{{numFormat.formatNumber(item.ndAmount)}}</v-flex>
                                </v-layout>
                            </div>
                            
                            <!-- manual adjustments -->
                            <div v-if="manual_adjustments_debit.length>0" ><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs3 class="text-xs-left"><h4>Manual Adjustments</h4></v-flex>
                                    <v-flex xs7 class="text-xs-left"><h4>Notes</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in manual_adjustments_debit" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs3 class="text-xs-left">{{item.manualAdjustmentType}}</v-flex>
                                    <v-flex xs7 class="text-xs-left">{{item.notes}}</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(item.amount*-1)}}</v-flex>
                                </v-layout>
                            </div>
                            <div v-if="manual_adjustments_credit.length>0" ><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs3 class="text-xs-left"><h4>Manual Adjustments</h4></v-flex>
                                    <v-flex xs7 class="text-xs-left"><h4>Notes</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in manual_adjustments_credit" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs3 class="text-xs-left">{{item.manualAdjustmentType}}</v-flex>
                                    <v-flex xs7 class="text-xs-left">{{item.notes}}</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(item.amount)}}</v-flex>
                                </v-layout>
                            </div>

                            <!-- unpaid leaves -->
                            <div v-if="unpaid_leaves != null"><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">
                                        <h4>LWOP</h4>
                                    </v-flex>
                                    <v-flex v-if="!isMobile" xs2 class="text-xs-right">      
                                        <h4>Hourly Rate Amount</h4>
                                    </v-flex> 
                                    <v-flex v-if="!isMobile" xs1 class="text-xs-right">      
                                        <h4>Hours</h4>
                                    </v-flex> 
                                    <v-flex xs1 class="text-xs-right">      
                                        <h4>Amount</h4>
                                    </v-flex> 
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">
                                        {{unpaid_leaves.leaveName}}
                                    </v-flex>
                                    <v-flex v-if="!isMobile" xs2 class="text-xs-right">      
                                        {{numFormat.formatNumber(unpaid_leaves.hourlyRate)}}
                                    </v-flex> 
                                    <v-flex v-if="!isMobile" xs1 class="text-xs-right">      
                                        {{numFormat.formatNumber(unpaid_leaves.hours)}}
                                    </v-flex> 
                                    <v-flex xs1 class="text-xs-right">      
                                        {{numFormat.formatNumber(unpaid_leaves.amount*-1)}}
                                    </v-flex> 
                                </v-layout>
                            </div>
                            
                            <!-- unpaid days -->
                            <div v-if="unpaid_days != null"><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">
                                        <h4>LWOP</h4>
                                    </v-flex>
                                    <v-flex v-if="!isMobile" xs2 class="text-xs-right">      
                                        <h4>Hourly Rate Amount</h4>
                                    </v-flex> 
                                    <v-flex v-if="!isMobile" xs1 class="text-xs-right">      
                                        <h4>Hours</h4>
                                    </v-flex> 
                                    <v-flex xs1 class="text-xs-right">      
                                        <h4>Amount</h4>
                                    </v-flex> 
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">
                                        {{unpaid_days.leaveName}}
                                    </v-flex>
                                    <v-flex v-if="!isMobile" xs2 class="text-xs-right">      
                                        {{numFormat.formatNumber(unpaid_days.hourlyRate)}}
                                    </v-flex> 
                                    <v-flex v-if="!isMobile" xs1 class="text-xs-right">      
                                        {{numFormat.formatNumber(unpaid_days.hours)}}
                                    </v-flex> 
                                    <v-flex xs1 class="text-xs-right">      
                                        {{numFormat.formatNumber(unpaid_days.amount*-1)}}
                                    </v-flex> 
                                </v-layout>
                            </div>

                            <!-- undertime deductions -->
                            <div v-if="undertime_deductions!=null"><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">
                                        <h4>Undertime</h4>
                                    </v-flex>
                                    <v-flex v-if="!isMobile" xs2 class="text-xs-right">      
                                        <h4>Hours</h4>
                                    </v-flex> 
                                    <v-flex xs2 class="text-xs-right">      
                                        <h4>Amount</h4>
                                    </v-flex> 
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">
                                        Undertime/Late Attendance
                                    </v-flex>
                                    <v-flex v-if="!isMobile" xs2 class="text-xs-right">      
                                        {{numFormat.formatNumber(undertime_deductions.totalLateHours)}}
                                    </v-flex> 
                                    <v-flex xs2 class="text-xs-right">      
                                        {{numFormat.formatNumber(undertime_deductions.amount*-1)}}
                                    </v-flex> 
                                </v-layout>
                            </div>

                            <!-- reimbursements -->
                            <div v-if="reimbursements.length>0"><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs6 class="text-xs-left"><h4>Reimbursements</h4></v-flex>
                                    <v-flex xs6 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in reimbursements" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs6 class="text-xs-left">{{item.reimbursementType}}</v-flex>
                                    <v-flex xs6 class="text-xs-right">{{numFormat.formatNumber(item.amount)}}</v-flex>
                                </v-layout>
                            </div>

                            <!-- leaves conversion -->
                            <div v-if="hasLeavesConversion" ><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left"><h4>CY {{annualization.fiscalYear}} Leaves Conversion</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>Days</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-if="annualization.slConversionAmount>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">Sick Leaves</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{annualization.slConvertedDays}}</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.slConversionAmount)}}</v-flex>
                                </v-layout>
                                <v-layout v-if="annualization.vlConversionAmount>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs8 class="text-xs-left">Vacation Leaves</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{annualization.vlConvertedDays}}</v-flex>
                                    <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.vlConversionAmount)}}</v-flex>
                                </v-layout>
                            </div>

                            <!-- tax refund -->
                            <div v-if="hasTaxRefund"><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs10 class="text-xs-left"><h4>CY {{annualization.fiscalYear}} Tax Refund</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(Math.abs(annualization.finalTaxAdjustments))}}</h4></v-flex>
                                </v-layout>
                            </div>

                            <div><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs6 class="text-xs-left"><h4>TOTAL EARNINGS</h4></v-flex>
                                    <v-flex xs6 class="text-xs-right"><h4>{{numFormat.formatNumber(totalEarnings)}}</h4></v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                        <v-card-text v-else style="margin-left:10px;">Not Generated</v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- DEDUCTIONS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">DEDUCTIONS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading&&payroll_employee&&payroll_employee.status>0" >
                            
                            <!-- statutory deductions -->
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    <h4>Statutory Deductions</h4>
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    <h4>Amount</h4>
                                </v-flex>       
                            </v-layout> 
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    SSS Employee Contribution
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    {{numFormat.formatNumber(payroll_employee.cutOffSSSEmployeeContribution)}}
                                </v-flex>       
                            </v-layout> 
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    Pagibig Employee Contribution
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    {{numFormat.formatNumber(payroll_employee.cutOffPagibigEmployeeContribution)}}
                                </v-flex>       
                            </v-layout> 
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    Philhealth Employee Contribution
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">      
                                    {{numFormat.formatNumber(payroll_employee.cutOffPhilhealthEmployeeContribution)}}
                                </v-flex>       
                            </v-layout>

                            <!-- loan payments -->
                            <div v-if="loan_payments.length>0"><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs11 class="text-xs-left"><h4>Loan Payments</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in loan_payments" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs11 class="text-xs-left">{{item.loanType}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.amount)}}</v-flex>
                                </v-layout>
                            </div>

                            <!-- cash advances payments -->
                            <div v-if="cash_advances_payments.length>0" ><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs11 class="text-xs-left"><h4>Cash Advances Payments</h4></v-flex>
                                    <v-flex xs1 class="text-xs-right"><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,index) in cash_advances_payments" :key="index" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs11 class="text-xs-left">{{item.cashAdvanceType}}</v-flex>
                                    <v-flex xs1 class="text-xs-right">{{numFormat.formatNumber(item.amount)}}</v-flex>
                                </v-layout>
                            </div>
                            
                            <!-- tax withheld -->
                            <div><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'">
                                    <v-flex xs6 class="text-xs-left"><h4>Tax Withheld</h4></v-flex>
                                    <v-flex xs6 class="text-xs-right"><h4>{{numFormat.formatNumber(payroll_employee.cutOffTaxWithheld)}}</h4></v-flex>
                                </v-layout>
                            </div>
                            
                            <!-- annualization additional tax from previous calendar year-->
                            <div v-if="hasAddlTax">
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs10 class="text-xs-left"><h4>CY {{annualization.fiscalYear}} Additional Tax</h4></v-flex>
                                    <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.finalTaxAdjustments)}}</h4></v-flex>
                                </v-layout>
                            </div>

                            <!-- total deductions -->
                            <div><br>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'">
                                    <v-flex xs6 class="text-xs-left"><h4>TOTAL DEDUCTIONS</h4></v-flex>
                                    <v-flex xs6 class="text-xs-right"><h4>{{numFormat.formatNumber(totalDeductions)}}</h4></v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                        <v-card-text v-else style="margin-left:10px;">Not Generated</v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                 <!-- NET PAY -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">NET PAY</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading&&payroll_employee&&payroll_employee.status>0" >
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">
                                    <h4>NET PAY</h4>
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">  
                                    <!-- note: compuated netPay and cutOffNetPay should always be equal except if with annualization     -->
                                    <!-- annualization adjustments are already reflected on previous year's final taxable benefits, final taxable income, final tax -->
                                    <!-- annualization adjustments just need to be reflected in the payslip and control report -->
                                    <b>{{numFormat.formatNumber(netPay)}}</b>
                                </v-flex>       
                            </v-layout> 
                        </v-card-text>
                        <v-card-text v-else style="margin-left:10px;">Not Generated</v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deletePayroll"></delete>
        </v-dialog>
        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import commonfn from '@/common/functions'   //for refactor
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import { hasDeleteRights, hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default {     
    name: 'Payroll',
    metaInfo: {
        title: 'Payroll',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, generate payroll' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'delete': () => import('@/components/BasicPopups/Delete'),
    },   
    data () {
        return {
            commonfn,
            numFormat,
            awsS3Helper,
            error: false,
            errorMessage: '',
            y: null,
            x: null,
            snackbar: false,
            snackbarText: '',
            loading: false,
            dialogPreview: false,
            dialogDelete: false,
            panel: [true],
            message: null,
            expand: false,
            menu_status: false,
            cutoff_period: [],
            cutoff_settings: null,
            payroll_employee: null,
            deminimis_benefits: [],
            other_benefits: [],
            fringe_benefits: [],
            overtime: [],
            night_diff: [],
            unpaid_leaves: null,
            unpaid_days: null,
            undertime_deductions: null,
            manual_adjustments_credit: [],
            manual_adjustments_debit: [],
            loan_payments: [],
            cash_advances_payments: [],
            reimbursements: [],
            annualization: null,
            employment: null,
            loading_pdf: false,
            loading_status: false,
        }
    },
    methods: {  
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/company/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        async payrollCredited() {
            //this will update only the status to Credited
           try {
                if (this.hasEditRights) {
                    this.loading_status = true

                    var data = {
                        userId: this.selectedUserId,
                        cutOffId: this.selectedCutoffId
                    }
                    const response = await payrollApi.payrollCredited(data)
                    if (response.status == 200) {
                        await this.getEmployeePayroll(false)
                        this.snackbarText = `Payroll status has been updated to Credited`
                        this.snackbar = true
                    }

                    this.loading_status = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async generatePayslipPDF(item) {
            try {
                this.loading_pdf = true
                var data = {
                    userId: item.userId,
                    cutOffId: item.cutOffId
                }
                const response = await payrollApi.getPayslipUrl(data)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(item.userId, response.data.fileName, AWSS3DocumentType.Paylips)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_pdf = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading_pdf[index].value = false
            }
        },  
        async getEmployeePayroll(run_loading) {
            try {
                this.loading = run_loading
                const response = await payrollApi.getByUser(this.selectedCutoffId, this.selectedUserId)
                if (response && response.status == 200) {
                    this.cutoff_period = response.data.cutoffItem
                    this.cutoff_settings = response.data.cutOffSettingsItem
                    this.payroll_employee = response.data.payrollItem
                    this.deminimis_benefits = response.data.deminimisItems
                    this.other_benefits = response.data.otherBenefitsItems
                    this.fringe_benefits = response.data.fringeBenefitsItems
                    this.overtime = response.data.overtimeItems
                    this.night_diff = response.data.nightDiffItems
                    this.unpaid_leaves = response.data.unpaidLeavesItems
                    this.unpaid_days = response.data.unpaidDaysItems
                    this.undertime_deductions = response.data.undertimeDeductions
                    this.manual_adjustments_credit = response.data.manualAdjustmentsItems.filter(item => {
                        return item.transType == 1
                    })
                    this.manual_adjustments_debit = response.data.manualAdjustmentsItems.filter(item => {
                        return item.transType == 2
                    })
                    this.loan_payments = response.data.loanPayments
                    this.cash_advances_payments = response.data.cashAdvances
                    this.reimbursements = response.data.reimbursements
                    this.annualization = response.data.annualizationItems
                    this.employment = response.data.employment
                }
                this.loading = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async approvePayroll() {
            try {
                if (this.hasApproverRights) {
                    this.loading_status = true
                    var data = {
                        userId: this.selectedUserId,
                        cutOffId: this.selectedCutoffId
                    }
                    const response = await payrollApi.approve(data)
                    if (response.status == 200) {
                        await this.getEmployeePayroll(false)
                        this.snackbarText = `Payroll has been approved`
                        this.snackbar = true
                    }
                    this.loading_status = false
                }
                
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async rejectPayroll() {
            try {
                if (this.hasApproverRights) {
                    this.loading_status = true
                    var data = {
                        userId: this.selectedUserId,
                        cutOffId: this.selectedCutoffId
                    }
                    const response = await payrollApi.reject(data)
                    if (response.status == 200) {
                        await this.getEmployeePayroll(false)
                        this.snackbarText = `Payroll has been rejected`
                        this.snackbar = true
                    }
                    this.loading_status = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async forReview() {
            try {
                if (this.hasEditRights) {
                    this.loading_status = true

                    var data = {
                        userId: this.selectedUserId,
                        cutOffId: this.selectedCutoffId
                    }
                    const response = await payrollApi.forReview(data)
                    if (response.status == 200) {
                        await this.getEmployeePayroll(false)
                        this.snackbarText = `Payroll is now pending review`
                        this.snackbar = true
                    }

                    this.loading_status = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async generatePayrollByUser() {
            try {
                this.loading_status = true
                    
                var data = {
                    userId: this.selectedUserId,
                    cutOffId: this.selectedCutoffId
                }
                const response = await payrollApi.generateByUser(data)
                if (response.status == 200) {
                    await this.getEmployeePayroll(false)
                    this.snackbarText = `Payroll successfully generated`
                    this.snackbar = true
                }

                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showDelete() {
            this.$refs.refDeleteComponent.setMessage("Delete this payroll?")
            this.$refs.refDeleteComponent.setNote("Note: You can still reprocess the payroll after deletion.")
            this.dialogDelete = true
        },
        async deletePayroll() {
            //todo - replace hasEditRights with hasDeleteRights
            if (this.hasEditRights) {  
                    this.dialogDelete = false
                    this.loading_status = true

                    var data = {
                        userId: this.selectedUserId,
                        cutOffId: this.selectedCutoffId
                    }
                    const response = await payrollApi.delete(data)
                    if (response.status == 200) {
                        await this.getEmployeePayroll(false)
                        this.snackbarText = `Payroll has been deleted`
                        this.snackbar = true
                    }

                    this.loading_status = false
                }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getEmployeePayroll(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Payslip'
        })

        this.getEmployeePayroll(true)
    },
    computed: {
        pageQueryId() {
            return `payslip${this.selectedCutoffId}${this.selectedUserId}`
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        hasEditAndApproverRights() {
            return this.hasEditRights && this.hasApproverRights
        },
        showMenuButtons() {
            return !this.loading &&
                    this.payroll_employee &&
                    this.payroll_employee.status!=commonfn.getStatusCode('Not Available')
        },
        commentsData() {
            if (this.payroll_employee) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.payroll,
                    notificationTypeId: notificationTypes.payroll_details
                }
            }
        },
        isHourlySalaryType() {
            if (this.payroll_employee) {
                return commonfn.getSalaryTypeName(this.payroll_employee.salaryType) == 'Hourly'
            }
        },
        selectedCutoffId() {
            return this.$route.params.id
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        getCoverageDesc() {
            if (this.loading) return;
             
            const start = this.$moment(this.cutoff_period.cutoffStart);
            const end = this.$moment(this.cutoff_period.cutoffEnd);

            const sameYear = start.year() === end.year();
            const sameMonth = start.month() === end.month() && sameYear;

            if (sameMonth) {
                // Aug 1–15, 2025
                return `${start.format('MMM D')} - ${end.format('D, YYYY')}`;
            }

            if (sameYear) {
                // Aug 25 – Sep 10, 2025
                return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
            }

            // Dec 26, 2025 – Jan 10, 2026
            return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
        },
        openCutOffPeriod() {
            if (this.cutoff_period!=null) return this.cutoff_period.status==commonfn.getStatusCode('Open')
        },
        closedCutOffPeriod() {
            if (this.cutoff_period!=null) return this.cutoff_period.status==commonfn.getStatusCode('Closed')
        },
        canGenerate() {
            return this.hasEditRights&&
                    this.payroll_employee&&
                    this.payroll_employee.status==commonfn.getStatusCode('Not Available')&&
                    this.payroll_employee.timeReportStatus==commonfn.getStatusCode('Approved')
        },
        totalEarnings() {
            //for refactor, compute in API then return total amounts
            //but this can be used as reconciliation between backend vs UI totals
            var unpaidleaves = this.unpaid_leaves != null ? this.unpaid_leaves.amount : 0
            var unpaidDays = this.unpaid_days != null ? this.unpaid_days.amount : 0
            var undertime = this.undertime_deductions != null ? this.undertime_deductions.amount : 0
            var manual_adj_debit = this.manual_adjustments_debit.length > 0 ? this.manual_adjustments_debit.map(x => x.amount).reduce((prev,next) => prev + next) : 0

            var deminimis = this.deminimis_benefits.length > 0 ? this.deminimis_benefits.map(x => x.cutOffAmount).reduce((prev, next) => prev + next) : 0
            var other_benefits = this.other_benefits.length > 0 ? this.other_benefits.map(x => x.cutOffAmount).reduce((prev, next) => prev + next) : 0
            var fringe_benefits = this.fringe_benefits.length > 0 ? this.fringe_benefits.map(x => x.cutOffAmount).reduce((prev, next) => prev + next) : 0
            var overtime = this.overtime.length > 0 ? this.overtime.map(x => x.amount).reduce((prev, next) => prev + next) : 0
            var night_diff = this.night_diff.length > 0 ? this.night_diff.map(x => x.ndAmount).reduce((prev, next) => prev + next) : 0
            var reimbursementAmt = this.reimbursements.length > 0 ? this.reimbursements.map(x => x.amount).reduce((prev, next) => prev + next) : 0
            var manual_adj_credit = this.manual_adjustments_credit.length > 0 ? this.manual_adjustments_credit.map(x => x.amount).reduce((prev,next) => prev + next) : 0
            var slConversion = this.annualization!=null?this.annualization.slConversionAmount:0
            var vlConversion = this.annualization!=null?this.annualization.vlConversionAmount:0

            //finalTaxAdjustments is negative if refund (overwithheld), 
            // positive if add'l tax (underwithheld)
            var taxRefund = this.hasTaxRefund?Math.abs(this.annualization.finalTaxAdjustments):0

            var total = this.payroll_employee.cutOffBasicSalary + 
                        deminimis +
                        other_benefits +
                        fringe_benefits + 
                        overtime +
                        night_diff +
                        manual_adj_credit + 
                        reimbursementAmt +
                        slConversion +
                        vlConversion + 
                        taxRefund + 
                        (unpaidleaves*-1) +
                        (unpaidDays*-1) +
                        (undertime*-1) + 
                        (manual_adj_debit *-1)
                        
            return total
        },
        totalDeductions() {            
            var addlTax = this.hasAddlTax?this.annualization.finalTaxAdjustments:0
            var loanPayments = this.loan_payments.length>0? this.loan_payments.map(x=>x.amount).reduce((prev,next)=>prev+next):0
            var cashAdvancesPayments = this.cash_advances_payments.length>0? this.cash_advances_payments.map(x=>x.amount).reduce((prev,next)=>prev+next):0
            
            return this.payroll_employee.cutOffSSSEmployeeContribution +
                    this.payroll_employee.cutOffPagibigEmployeeContribution +
                    this.payroll_employee.cutOffPhilhealthEmployeeContribution +
                    this.payroll_employee.cutOffTaxWithheld +                   
                    loanPayments +
                    cashAdvancesPayments +
                    addlTax
        },
        netPay() {
            return this.totalEarnings-this.totalDeductions
        },  
        hasLeavesConversion() {
            if (this.annualization) 
                return this.annualization.slConversionAmount>0||this.annualization.vlConversionAmount>0
            return false
        },
        hasTaxRefund() {
            if (this.annualization) return this.annualization.finalTaxAdjustments<0
            return false
        },
        hasAddlTax() {
            if (this.annualization) return this.annualization.finalTaxAdjustments>0
            return false
        },
        created_status() {
            if (this.payroll_employee)
                return this.payroll_employee.status==commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.payroll_employee)
                return this.payroll_employee.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.payroll_employee)
                return this.payroll_employee.status==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.payroll_employee)
                return this.payroll_employee.status==commonfn.getStatusCode('Rejected')
        },
        credited_status() {
            if (this.payroll_employee)
                return this.payroll_employee.status==commonfn.getStatusCode('Credited')
        },
        published_status() {
            if (this.payroll_employee)
                return this.payroll_employee.status==commonfn.getStatusCode('Published')
        },        
        disabledApproverRights() {
            return this.openCutOffPeriod||
                    this.closedCutOffPeriod||
                    this.created_status||
                    this.published_status
        },
        disabledEditRights() {
            return this.openCutOffPeriod||
                    this.closedCutOffPeriod||
                    this.forReview_status||
                    this.credited_status||
                    this.published_status
        },
        disabledForEditAndApproverRights() {
            return this.openCutOffPeriod||
                    this.closedCutOffPeriod||
                    this.published_status
        },
        hasResigned() {
            if (!this.loading) {
                return this.employment.employmentStatus==commonfn.getStatusCode('Resigned')
            }
        },
        hasStartedLaterThanCutoffStartDate() {
            if (!this.loading) {
                return this.employment.startDate > this.cutoff_period.cutoffStart && 
                        this.employment.startDate <= this.cutoff_period.cutoffEnd
            }
        }
    }
}
</script>
<style scoped>
    .section-layout {
        padding:0px 50px 0px 50px;
    }
    .section-layout-mobile {
        padding:0px;
    }
    .section-alert {
        margin:8px 0px 8px 0px;
    }
</style>